module.exports = __webpack_public_path__ + "img/blank_profile.76d6ceed.svg";